exports.projects = [
  {
    name: "Pedestrian Perceptions of Heat and Shade in Route Planning",
    description:
      "In this project, we are exploring how pedestrians perceive heat and shade in their route planning decisions and how they utilize technology in routing decisions",
    tags: [""],
  },
  {
    name: "Cool Routes: Real-Time Human Thermal Exposure Routing",
    description:
      "In this project, we propose a routing app based on SOLWEIG - a physics based model to reduce the heat exposure of pedesstrians.",
    tags: ["SOLWEIG", "Thermal Comfort", "HPC", "TypeScript", "Python"],
  },
  {
    name: "Outdoor Heat Exposure Assessing Thermal Walkability in PASS Neighborhoods",
    description:
      "This project aims to assess the thermal comfort of pedestrians in twelve neighborhoods in Phoenix, AZ, using the SOLWEIG model. This project is funded by the CAP LTER - a NSF funded project.",
    tags: ["CAP LTER", "SOLWEIG", "Thermal Comfort", "HPC", "QGIS", "Python"],
  },
  {
    name: "Shade-Tool",
    description:
      "A web-based tool to determine and visualize the tree/umbrella shade.",
    tags: ["React", "Python"],
  },
];